import { render } from "./AXBinventory.vue?vue&type=template&id=1f3c1266&scoped=true"
import script from "./AXBinventory.vue?vue&type=script&lang=js"
export * from "./AXBinventory.vue?vue&type=script&lang=js"

import "./AXBinventory.vue?vue&type=style&index=0&id=1f3c1266&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f3c1266"

export default script